import { Form } from '@unform/web';
import React, { useEffect, useState } from 'react';
import { FaBell, FaCertificate, FaCheckCircle, FaExclamationCircle, FaFile, FaIdBadge, FaImages, FaQuestionCircle, FaReceipt, FaRegIdBadge, FaSubscript, FaTicketAlt, FaTrophy, FaUser } from 'react-icons/fa';
import { FiMessageCircle } from 'react-icons/fi';

import { IconType } from 'react-icons/lib';
import { useAuth } from '../../../../hooks/Auth';
import { useConfiguration } from '../../../../hooks/Configuration';
import api from '../../../../services/api';



import { Container, ContainerWhite } from './styles';
import { useParams } from 'react-router-dom';
import { useModal } from '../../../../hooks/Modal';

import { useLoading } from '../../../../hooks/LoadingHook';
 





const SaleList: React.FC<Record<string, any>> = ({ accessType, sales, products }) => {
  const { user } = useAuth();
  const { addLoading, removeLoading } = useLoading();
  const { addModal } = useModal();


  const [contador, setContador] = useState(5)

  const [filter, setFilter] = useState('');
  const [group, setGroup] = useState('payment_status_id_title');

  const salesFiltered = filter ? sales?.filter(sale => sale?.payment_status_id === filter) : sales;


  const getTotal = (list) => {


    const totalPaid = list?.reduce((prev, item) => {
      prev += item?.paid;
      return prev;

    }, 0)

    const totalCourtesy = list?.reduce((prev, item) => {
      prev += item?.courtesy;
      return prev;

    }, 0)

    const totalWaiting = list?.reduce((prev, item) => {
      prev += item?.waiting;
      return prev;

    }, 0)

    const totalWaitingCourtesy = list?.reduce((prev, item) => {
      prev += item?.waiting_courtesy;
      return prev;

    }, 0)

    return {
      paid: totalPaid,
      courtesy: totalCourtesy,
      waiting: totalWaiting,
      waiting_courtesy: totalWaitingCourtesy
    }

  }

  const subscriptions = sales?.filter(i => i?.product_id_response?.is_subscription === 'yes');


  const notSubscriptions = sales?.filter(i => i?.product_id_response?.is_subscription !== 'yes');

  const subscriptionsReport = subscriptions?.reduce((prev, item) => {

    const index = prev.findIndex(i => i?.product_id === item?.product_id);

    if (index < 0) {
      prev.push({
        quantity: item?.product_id_response?.total_quantities,
        product_id: item?.product_id,
        product_id_response: item?.product_id_response,
        paid: 0,
        courtesy: 0,
        waiting: 0,
        waiting_courtesy: 0,
        total: 0
      })
    }

    const checkIndex = index < 0 ? (prev?.length - 1) : index;

    if (item.payment_status_id === 'paid') {


      if (item?.total > 0) {
        prev[checkIndex].paid += 1;
      }
      else {
        if (item?.client_id) {
          prev[checkIndex].courtesy += 1;
        }
        else {
          prev[checkIndex].waiting_courtesy += 1;
        }
      }
      prev[checkIndex].total += 1;
    }
    else if (item.payment_status_id === 'waiting') {
      prev[checkIndex].waiting += 1;
      prev[checkIndex].total += 1;
    }

    return prev;
  }, [])


  const totalSubscription = getTotal(subscriptionsReport)


  const notSubscriptionsReport = notSubscriptions?.reduce((prev, item) => {

    const index = prev.findIndex(i => i?.product_id === item?.product_id);

    if (index < 0) {
      prev.push({
        quantity: item?.product_id_response?.total_quantities,
        product_id: item?.product_id,
        product_id_response: item?.product_id_response,
        paid: 0,
        courtesy: 0,
        waiting: 0,
        waiting_courtesy: 0,
        total: 0
      })
    }

    const checkIndex = index < 0 ? (prev?.length - 1) : index;

    if (item.payment_status_id === 'paid') {


      if (item?.total > 0) {
        prev[checkIndex].paid += 1;
      }
      else {
        if (item?.client_id) {
          prev[checkIndex].courtesy += 1;
        }
        else {
          prev[checkIndex].waiting_courtesy += 1;
        }
      }
      prev[checkIndex].total += 1;
    }
    else if (item.payment_status_id === 'waiting') {
      prev[checkIndex].waiting += 1;
      prev[checkIndex].total += 1;
    }

    return prev;
  }, [])

  const totalNotSubscription = getTotal(notSubscriptionsReport)

  return <Container>



    <h2 style={{ textAlign: 'left', width: '100%', maxWidth: '1400px' }}>
      Categorias de inscrição
    </h2>

    <table className='tableRef'>
      <tbody>
        <tr>

          <th className='primary' ><strong>Categoria</strong></th>


          <th className='primary'><strong>Inscrições Pagas</strong></th>
          <th className='primary'><strong>Cortesias utilizadas</strong></th>

          <th className='primary'><strong>Total de vagas preenchidas</strong><br />
            (Pagas + cortesias utilizadas)
          </th>
          <th className='primary'><strong>Vagas Totais</strong></th>
          <th className='primary'><strong>% Ocupação real</strong></th>
          <th className='secondary' ><strong>Inscrições pendentes</strong><br />
            (Aguardando aprovação)</th>


          <th className='secondary' ><strong>Cortesias pendentes</strong><br />
            (Não retiradas)</th>


          <th className='secondary' ><strong>Total de inscrições pendentes</strong></th>


        </tr>
        {subscriptionsReport?.map(product => {
          const percent = product?.quantity ? `${(((product?.courtesy + product?.paid) / parseInt(product?.quantity, 10)) * 100)?.toFixed(2)}%` : '-';




          return <tr key={product?.product_id_response?._id}>
            <td>{product?.product_id_response?.title}</td>
            <td>{product?.paid}</td>
            <td>{product?.courtesy}</td>
            <td>{product?.courtesy + product?.paid}</td>
            <td>{product?.product_id_response?.total_quantities || '-'}</td>
            <td>{percent}</td>


            <td>{product?.waiting}</td>
            <td>{product?.waiting_courtesy}</td>
            <td>{product?.waiting + product?.waiting_courtesy}</td>
          </tr>


        })}
        <tr><td>  </td>
          <td> <strong>{totalSubscription?.paid}</strong> </td>
          <td> <strong>{totalSubscription?.courtesy}</strong> </td>
          <td> <strong>{totalSubscription?.courtesy + totalSubscription?.paid}</strong> </td>
          <td>  </td>
          <td>  </td>
          <td> <strong>{totalSubscription?.waiting}</strong> </td>
          <td> <strong>{totalSubscription?.waiting_courtesy}</strong> </td>
          <td> <strong>{totalSubscription?.waiting_courtesy + totalSubscription?.waiting}</strong> </td>

        </tr>
      </tbody>
    </table>

    <h2 style={{ textAlign: 'left', width: '100%', maxWidth: '1400px' }}>Categorias adicionais</h2>

    <table className='tableRef'>
      <tbody>
        <tr>

          <th className='primary' ><strong>Categoria</strong></th>


          <th className='primary'><strong>Inscrições Pagas</strong></th>
          <th className='primary'><strong>Cortesias utilizadas</strong></th>

          <th className='primary'><strong>Total de vagas preenchidas</strong><br />
            (Pagas + cortesias utilizadas)
          </th>
          <th className='primary'><strong>Vagas Totais</strong></th>
          <th className='primary'><strong>% Ocupação real</strong></th>
          <th className='secondary' ><strong>Inscrições pendentes</strong>
            (Aguardando aprovação)</th>


          <th className='secondary' ><strong>Cortesias pendentes</strong>
            (Não retiradas)</th>


          <th className='secondary' ><strong>Total de inscrições pendentes</strong></th>


        </tr>
        {notSubscriptionsReport?.map(product => {
          const percent = product?.quantity ? `${(((product?.courtesy + product?.paid) / parseInt(product?.quantity, 10)) * 100)?.toFixed(2)}%` : '-';




          return <tr key={product?.product_id_response?._id}>
            <td>{product?.product_id_response?.title}</td>
            <td>{product?.paid}</td>
            <td>{product?.courtesy}</td>
            <td>{product?.courtesy + product?.paid}</td>
            <td>{product?.product_id_response?.total_quantities || '-'}</td>
            <td>{percent}</td>


            <td>{product?.waiting}</td>
            <td>{product?.waiting_courtesy}</td>
            <td>{product?.waiting + product?.waiting_courtesy}</td>
          </tr>


        })}
        <tr><td>  </td>
          <td> <strong>{totalNotSubscription?.paid}</strong> </td>
          <td> <strong>{totalNotSubscription?.courtesy}</strong> </td>
          <td> <strong>{totalNotSubscription?.courtesy + totalNotSubscription?.paid}</strong> </td>
          <td>  </td>
          <td>  </td>
          <td> <strong>{totalNotSubscription?.waiting}</strong> </td>
          <td> <strong>{totalNotSubscription?.waiting_courtesy}</strong> </td>
          <td> <strong>{totalNotSubscription?.waiting_courtesy + totalNotSubscription?.waiting}</strong> </td>

        </tr>
      </tbody>
    </table>

  </Container>






}
export default SaleList;
